import { z } from 'zod'

export const formValidationErrorMapping: z.ZodErrorMap = (error) => {
  if (
    (error.code === 'invalid_type' && error.received === 'undefined') ||
    (error.code === 'too_small' && error.type === 'string') ||
    (error.code === 'invalid_enum_value' && error.received === '')
  ) {
    return {
      message: 'required',
    }
  }
  return {
    message: error.code,
  }
}
